const initState = {
  reports: [],
};

const reportReducer = (state = initState, action) => {
  switch (action.type) {
    case "SET_REPORTS":
      return { ...state, reports: action.payload };
    default:
      return state;
  }
};

export default reportReducer;
